/**
 * Development authentication bypass
 * Allows testing without Keycloak when VITE_DISABLE_AUTH=true
 */

export const DEV_AUTH_ENABLED = import.meta.env.VITE_DISABLE_AUTH === 'true'

export const DEV_USER = {
  name: 'Dev User',
  email: 'dev@example.com',
  roles: ['admin', 'developer', 'business_analyst', 'support_agent'],
}

/**
 * Check if we should bypass Keycloak
 */
export function shouldBypassAuth(): boolean {
  return DEV_AUTH_ENABLED
}

